import React from "react";
import styled from "@emotion/styled";
import { User, UserImpactAggregates } from "@ecologi/shared";
import { SupportedProjects } from "./components/SupportedProjects";
import { Wrapper } from "../Wrapper";
import { Section } from "../Section";
import { Typography } from "../Typography";
import styles from "./ProfileProjects.module.scss";

const ProjectInsightsLink = styled(Typography)`
  display: block;
  margin-bottom: 33px;
`;

export interface ProfileProjectProps {
  userImpactAggregates: UserImpactAggregates;
  isOwnProfile: boolean;
  user: User;
}

export const ProfileProjects = ({
  userImpactAggregates,
  isOwnProfile,
  user,
}: ProfileProjectProps) => {
  const title = isOwnProfile
    ? "Climate projects you've supported"
    : user.isFamilyPlan
    ? "Climate projects this family have supported"
    : `Climate projects ${user.firstName} has supported`;

  return (
    <Section className={styles.profileProjects}>
      <Section.Heading
        title={
          user.isBusinessType
            ? `Climate projects ${user.groupName} has supported`
            : title
        }
        subtitle={`${
          isOwnProfile
            ? "Your "
            : user.isFamilyPlan || user.isBusinessType
            ? "Their"
            : user.firstNamePlural
        } funding directly supports climate projects all over the world`}
        marginBottomOverride="0px"
      />

      {isOwnProfile && (
        <ProjectInsightsLink
          use="standaloneLink"
          as="a"
          href="/project-insights"
        >
          Visit project insights page
        </ProjectInsightsLink>
      )}

      <Wrapper id="tour-projects">
        <SupportedProjects userImpactAggregates={userImpactAggregates} />
      </Wrapper>
    </Section>
  );
};
